import React from 'react';
import FormComp from './components/FormComp';
import Consejo from './components/Consejo';
import Apuestas from './components/apuestas';
import AdminOverbox from './components/AdminOverbox';
import AdminReward from './components/AdminReward';
import AdminBirux from './components/AdminBirux';
import AdminCodeReward from './components/AdminCodeReward';
import AdminDrops from './components/AdminDrops';
import AdminLigas from './components/AdminLigas';
import AdminMetricas from './components/AdminMetricas';
import AdminEventos from './components/AdminEventos';
import AdminAlertas from './components/AdminAlertas';
import AdminTorneos from './components/AdminTorneos';
import AdminArena from './components/AdminArena';
import AdminTutorial from './components/AdminTutorial';
import { text } from 'body-parser';

const AdminPanel = () => {

  const [actualForm, setActualForm] = React.useState([]);
  const [actualPath, setActualPath] = React.useState('');
  const [actualPage, setActualPage] = React.useState('forms');
  const [initialData, setInitialData] = React.useState(null);
  const [darTab, setDarTab] = React.useState('overbox');

  const commandsForm = {
    name: {
      className: 'userSearch',
      placeholder: 'Nombre',
      type: 'text',
    },
    description: {
      className: 'userSearch',
      placeholder: 'Descripcion',
      type: 'text',
    },
    command: {
      className: 'userSearch',
      placeholder: 'Comando',
      type: 'text',
    },
    example: {
      className: 'userSearch',
      placeholder: 'Ejemplo',
      type: 'text',
    },
    image: {
      className: 'userSearch',
      placeholder: 'Link de imagen',
      type: 'text',
    },
    social: {
      className: 'userSearch',
      placeholder: 'Red Social',
      type: 'text',
    },
    cooldown: {
      className: 'userSearch',
      placeholder: 'Cooldown',
      type: 'number',
    },
    price: {
      className: 'userSearch',
      placeholder: 'Precio',
      type: 'number',
    },
  };

  const rewardsForm = {
    selectToEdit: {
      className: 'userSearch',
      placeholder: 'Seleccionar recompensa',
      type: 'select',
      data: 'rewards'
    },
    name: {
      className: 'userSearch',
      placeholder: 'Nombre',
      type: 'text',
    },
    description: {
      className: 'userSearch',
      placeholder: 'Descripcion',
      type: 'text',
    },
    text: {
      className: 'userSearch',
      placeholder: 'Texto',
      type: 'text',
    },
    example: {
      className: 'userSearch',
      placeholder: 'Ejemplo',
      type: 'text',
    },
    requiresText: {
      placeholder: 'Pedir texto al usar la recompensa',
      type: 'checkbox',
      className: 'foralliaCheckBox',
      text: 'Pedir texto al usar'
    },
    // Funcion enlazada: las claves son las de apps/rewardFunctions.js.
    fn: {
      className: 'heroes selectForm',
      placeholder: 'Función al usarla',
      type: 'staticSelect',
      optional: true,
      options: [
        { value: '', label: 'Sin función' },
        { value: 'tts', label: 'Leer en voz alta el texto del usuario (pide el texto siempre)' },
        { value: 'recargarVidas', label: 'Recargar combates de la arena (+3, aunque ya tenga el máximo)' },
        { value: 'darMiniOverbox', label: 'Dar 1 Mini Overbox' },
        { value: 'vipTwitch', label: 'Tirada VIP: un 1% de hacerle VIP de Twitch al momento (solo la ve quien entra con Twitch)' }
      ]
    },
    image: {
      className: 'userSearch',
      placeholder: 'Imagen',
      type: 'file',
    },
    cooldown: {
      className: 'userSearch',
      placeholder: 'Cooldown',
      type: 'number',
    },
    price: {
      className: 'userSearch',
      placeholder: 'Precio',
      type: 'number',
    },
    karmaType: {
      className: 'userSearch',
      placeholder: 'Tipo de Karma, 0: Neutro, 1: Heroe, 2: Villano',
      type: 'number',
    },
    game: {
      className: 'userSearch',
      placeholder: 'Juego',
      type: 'select',
      data: 'gameNames'
    },
    status: {
      placeholder: 'Estado',
      type: 'checkbox',
      className: 'foralliaCheckBox',
      text: 'Estado'
    },
    skipQueue: {
      placeholder: 'Saltar cola (pasa por delante de las demás)',
      type: 'checkbox',
      className: 'foralliaCheckBox',
      text: 'Saltar cola'
    },
    type: {
      placeholder: 'Tipo 0 = BiruxBronce, Tipo 1 = BiruxComodin, Tipo 3 BiruxPlata, Tipo 4 BiruxOro',
      type: 'number',
      className: 'userSearch',
    },
    autoBalance: {
      placeholder: 'Autobalanceo',
      type: 'checkbox',
      className: 'foralliaCheckBox',
      text: 'Autobalanceo activado'
    },
    balanceWindow: {
      className: 'heroes selectForm',
      placeholder: 'Ventana de tiempo',
      type: 'staticSelect',
      options: [
        { value: 'daily', label: 'Diaria' },
        { value: 'weekly', label: 'Semanal' },
        { value: 'monthly', label: 'Mensual' }
      ]
    },
    limitMin: {
      className: 'userSearch',
      placeholder: 'Limite minimo (baja precio si no se alcanza)',
      type: 'number',
    },
    limitMax: {
      className: 'userSearch',
      placeholder: 'Limite maximo (sube precio al superar)',
      type: 'number',
    },
    limitDefinitive: {
      className: 'userSearch',
      placeholder: 'Limite definitivo (0 = sin limite)',
      type: 'number',
    },
    priceStep: {
      className: 'userSearch',
      placeholder: 'Paso de precio (0 = 10% del base)',
      type: 'number',
    },
    priceMin: {
      className: 'userSearch',
      placeholder: 'Precio minimo (0 = sin minimo)',
      type: 'number',
    },
    priceMax: {
      className: 'userSearch',
      placeholder: 'Precio maximo (0 = sin maximo)',
      type: 'number',
    },
    realMoneyValue: {
      className: 'userSearch',
      placeholder: 'Valor en € real (vacío = no cuenta para presupuesto)',
      type: 'number',
    },
    excludeFromBudget: {
      placeholder: 'Excluir del presupuesto mensual',
      type: 'checkbox',
      className: 'foralliaCheckBox',
      text: 'No cuenta para el presupuesto (sigue escalando con el ratio)'
    },
    hasTimer: {
      placeholder: 'Recompensa temporal (con cuenta atras)',
      type: 'checkbox',
      className: 'foralliaCheckBox',
      text: 'Recompensa temporal'
    },
    timerSeconds: {
      className: 'userSearch',
      placeholder: 'Duracion del timer en segundos (0 = sin timer)',
      type: 'number',
    },
    streamLimit: {
      className: 'userSearch',
      placeholder: 'Usos por directo entre todos (vacio o 0 = sin limite)',
      type: 'number',
      optional: true,
    },
    streamReward: {
      placeholder: 'De directo (solo se usa en directo y no en los ultimos 5 minutos)',
      type: 'checkbox',
      className: 'foralliaCheckBox',
      text: 'Recompensa de directo'
    },
  };

  const overInfoForm = {
    id: {
      className: 'userSearch',
      placeholder: 'Id del elemento',
      type: 'text',
    },
    title: {
      className: 'userSearch',
      placeholder: 'Titulo del PopUp',
      type: 'text',
    },
    description: {
      className: 'userSearch',
      placeholder: 'Descripcion',
      type: 'text',
    },
    youtubeVideo: {
      className: 'userSearch',
      placeholder: 'Enlace del video de youtube',
      type: 'text',
    },
    instagramVideo: {
      className: 'userSearch',
      placeholder: 'Enlace del video de instagram',
      type: 'text',
    }
  };

  const scheduleForm = {
    selectToEdit: {
      className: 'userSearch',
      placeholder: 'Editar un directo ya programado',
      type: 'select',
      data: 'schedules'
    },
    title: {
      className: 'userSearch',
      placeholder: 'Titulo',
      type: 'text',
    },
    youtubeChannel: {
      className: 'userSearch',
      placeholder: 'Canal de YouTube',
      type: 'staticSelect',
      options: [
        { value: 'NaruxForAll', label: 'NaruxForAll' },
        { value: 'NaruxForPoke', label: 'NaruxForPoke' },
      ],
    },
    type: {
      className: 'userSearch',
      placeholder: 'Tipo',
      type: 'text',
    },
    timeStart: {
      className: 'userSearch',
      placeholder: 'Hora de inicio',
      type: 'datetime-local',
    },
    timeEnd: {
      className: 'userSearch',
      placeholder: 'Hora de fin',
      type: 'datetime-local',
    },
    recurrence: {
      placeholder: 'Recurrencia',
      type: 'checkbox',
      className: 'foralliaCheckBox',
      text: 'Recurrencia'
    },
    game: {
      className: 'userSearch',
      placeholder: 'Juego',
      type: 'select',
      data: 'activeGames'
    },
    events: {
      className: 'userSearch',
      placeholder: 'Eventos del directo (opcional)',
      type: 'multiSelect',
      data: 'events'
    },
    thumbnail: {
      className: 'userSearch',
      placeholder: 'Miniatura YouTube (max 2MB)',
      type: 'file',
    },
  };

  const missionsForm = {
    selectToEdit: {
      className: 'userSearch',
      placeholder: 'Seleccionar misión',
      type: 'select',
      data: 'missions'
    },
    name: {
      className: 'userSearch',
      placeholder: 'Nombre',
      type: 'text',
    },
    description: {
      className: 'userSearch',
      placeholder: 'Descripción',
      type: 'text',
    },
    icon: {
      className: 'userSearch',
      placeholder: 'Icono (URL o nombre)',
      type: 'text',
    },
    trackingType: {
      className: 'userSearch',
      placeholder: 'Tipo de tracking',
      type: 'staticSelect',
      options: [
        { value: 'watch_time', label: 'Tiempo de visionado (total)' },
        { value: 'daily_watch_time', label: 'Tiempo de visionado (diario)' },
        { value: 'messages', label: 'Mensajes (total)' },
        { value: 'daily_messages', label: 'Mensajes (diarios)' },
        { value: 'likes', label: 'Likes' },
        { value: 'subscriptions', label: 'Subscripciones' },
        { value: 'bits', label: 'Bits' },
        { value: 'overbox_opened', label: 'Overbox abiertas' },
        { value: 'custom', label: 'Custom' }
      ]
    },
    targetValue: {
      className: 'userSearch',
      placeholder: 'Valor objetivo',
      type: 'number',
    },
    resetType: {
      className: 'userSearch',
      placeholder: 'Tipo de reset',
      type: 'staticSelect',
      options: [
        { value: 'permanent', label: 'Permanente' },
        { value: 'daily', label: 'Diaria' },
        { value: 'weekly', label: 'Semanal' }
      ]
    },
    // Una casilla por recompensa: la mision da todas las que tengan mas de 0
    ...Object.fromEntries([
      ['overbox', 'Overbox'], ['birux', 'Birux'], ['biruxComodin', 'Birux Comodín'],
      ['biruxPlata', 'Birux Plata'], ['biruxOro', 'Birux Oro'], ['vidas', 'Combates de la arena']
    ].map(([tipo, nombre]) => ['reward_' + tipo, {
      className: 'userSearch',
      placeholder: nombre + ' (recompensa)',
      type: 'number',
      optional: true,
    }])),
    social: {
      className: 'userSearch',
      placeholder: 'Red Social',
      type: 'staticSelect',
      options: [
        { value: 'all', label: 'Todas' },
        { value: 'twitch', label: 'Twitch' },
        { value: 'tiktok', label: 'TikTok' },
        { value: 'youtube', label: 'YouTube' }
      ]
    },
    status: {
      placeholder: 'Estado',
      type: 'checkbox',
      className: 'foralliaCheckBox',
      text: 'Activa'
    },
  };

  // Codigos y premios de la web /codigos. Al activarse uno por primera vez se avisa a quien
  // tenga encendidas las notificaciones de codigos. El comando se escribe sin el "!" (p. ej.
  // "naruxbs xd") y el bot contesta el texto seguido del enlace a la web; sin imagen, la de la
  // Overbox. Las etiquetas van cortas porque la columna del formulario las trunca.
  const codesForm = {
    selectToEdit: {
      className: 'userSearch',
      placeholder: 'Editar un código ya creado',
      type: 'select',
      data: 'codes'
    },
    title: {
      className: 'userSearch',
      placeholder: 'Título',
      type: 'text',
    },
    description: {
      className: 'userSearch',
      placeholder: 'Descripción (opcional)',
      type: 'text',
      optional: true,
    },
    url: {
      className: 'userSearch',
      placeholder: 'Enlace del código o premio',
      type: 'text',
    },
    command: {
      className: 'userSearch',
      placeholder: 'Comando (opcional)',
      type: 'text',
      optional: true,
    },
    text: {
      className: 'userSearch',
      placeholder: 'Texto del comando',
      type: 'text',
      optional: true,
    },
    image: {
      className: 'userSearch',
      placeholder: 'Imagen (opcional)',
      type: 'file',
    },
    status: {
      placeholder: 'Activo (sale en la web y responde al comando)',
      type: 'checkbox',
      className: 'foralliaCheckBox',
    },
    featured: {
      placeholder: 'Destacado (sale arriba en la web; quita el anterior)',
      type: 'checkbox',
      className: 'foralliaCheckBox',
    },
    expired: {
      placeholder: 'Caducado (sigue en la web, sin enlace; marca también Activo)',
      type: 'checkbox',
      className: 'foralliaCheckBox',
    },
  };

  const conversionRateForm = {
    rate: {
      className: 'userSearch',
      placeholder: 'Tasa actual (1€ = X BiruxComodin)',
      type: 'number',
    },
    baseRate: {
      className: 'userSearch',
      placeholder: 'Tasa base/inicial',
      type: 'number',
    },
    adjustPercent: {
      className: 'userSearch',
      placeholder: '% de ajuste por autobalanceo (ej: 10)',
      type: 'number',
    },
    spendMin: {
      className: 'userSearch',
      placeholder: 'Umbral bajo en € (baja tasa si gasto < esto)',
      type: 'number',
    },
    spendMax: {
      className: 'userSearch',
      placeholder: 'Umbral alto en € (sube tasa si gasto > esto)',
      type: 'number',
    },
  };

  const ligaPokemonForm = {
    medallasMax: {
      className: 'userSearch',
      placeholder: 'Medallas máximas para completar la liga',
      type: 'number',
    },
  };

  const gameDefForm = {
    selectToEdit: {
      className: 'userSearch',
      placeholder: 'Seleccionar juego',
      type: 'select',
      data: 'games'
    },
    name: {
      className: 'userSearch',
      placeholder: 'Nombre del juego',
      type: 'text',
    },
    gameTwitchId: {
      className: 'userSearch',
      placeholder: 'Twitch ID del juego',
      type: 'text',
    },
    gameDiscordId: {
      className: 'userSearch',
      placeholder: 'Discord ID del juego',
      type: 'text',
    },
    discordChannelId: {
      className: 'userSearch',
      placeholder: 'Discord ID del canal (vacío: lo crea el bot)',
      type: 'text',
    },
    emoji: {
      className: 'userSearch',
      placeholder: 'Emoji del juego (canal y respuesta de Discord)',
      type: 'text',
    },
    image: {
      className: 'userSearch',
      placeholder: 'Imagen del juego (opcional)',
      type: 'file',
    },
    status: {
      placeholder: 'Estado',
      type: 'checkbox',
      className: 'foralliaCheckBox',
      text: 'Estado'
    },
    offstream: {
      placeholder: 'Juego activo offstream',
      type: 'checkbox',
      className: 'foralliaCheckBox',
      text: 'Juego activo offstream'
    },
    color: {
      className: 'userSearch',
      placeholder: 'Color del juego (hexadecimal)',
      type: 'color',
    },
  }

  return (
    <div className='page'>
      <div className='topTickets'>
        <h1>Admin Panel</h1>
        <div className='navTops heroes unselectable'>
          <div onClick={() => {
            setActualForm(Object.entries(rewardsForm));
            setActualPath('rewards');
            setActualPage('forms');
            setInitialData(null);
          }}>Recompensas</div>
          <div onClick={() => {
            setActualForm(Object.entries(commandsForm));
            setActualPath('commands');
            setActualPage('forms');
            setInitialData(null);
          }}>Comandos</div>
          <div onClick={() => {
            setActualForm(Object.entries(overInfoForm));
            setActualPath('overInfo');
            setActualPage('forms');
            setInitialData(null);
          }}>overInfo</div>
          <div onClick={() => {
            setActualForm(Object.entries(scheduleForm));
            setActualPath('schedule');
            setActualPage('forms');
            setInitialData(null);
          }}>Calendario</div>
          <div onClick={() => {
            setActualForm(Object.entries(gameDefForm));
            setActualPath('gameDef');
            setActualPage('forms');
            setInitialData(null);
          }}>Juegos</div>
          <div onClick={() => {
            setActualPage('ligas');
            setInitialData(null);
          }}>Ligas</div>
          <div onClick={() => {
            setActualPage('consejo');
            setInitialData(null);
          }}>Consejo</div>
          <div onClick={() => {
            setActualPage('apuestas');
            setInitialData(null);
          }}>Apuestas</div>
          <div onClick={() => {
            setActualForm(Object.entries(missionsForm));
            setActualPath('missions');
            setActualPage('forms');
            setInitialData(null);
          }}>Misiones</div>
          <div onClick={() => {
            setActualForm(Object.entries(conversionRateForm));
            setActualPath('conversionRate');
            setActualPage('forms');
            fetch('/api/conversionRate')
              .then(res => res.json())
              .then(data => setInitialData(data))
              .catch(() => setInitialData(null));
          }}>Tasa BiruxComodin</div>
          <div onClick={() => {
            setActualForm(Object.entries(ligaPokemonForm));
            setActualPath('ligaPokemon');
            setActualPage('forms');
            fetch('/api/ligaPokemon')
              .then(res => res.json())
              .then(data => setInitialData(data))
              .catch(() => setInitialData(null));
          }}>Liga Pokémon</div>
          <div onClick={() => {
            setActualPage('dar');
            setInitialData(null);
          }}>Dar</div>
          <div onClick={() => {
            setActualPage('codeReward');
            setInitialData(null);
          }}>Comando Recompensa</div>
          <div onClick={() => {
            setActualForm(Object.entries(codesForm));
            setActualPath('codes');
            setActualPage('forms');
            setInitialData(null);
          }}>Códigos</div>
          <div onClick={() => {
            setActualPage('drops');
            setInitialData(null);
          }}>Drops</div>
          <div onClick={() => {
            setActualPage('metricas');
            setInitialData(null);
          }}>Métricas</div>
          <div onClick={() => {
            setActualPage('eventos');
            setInitialData(null);
          }}>Eventos</div>
          <div onClick={() => {
            setActualPage('alertas');
            setInitialData(null);
          }}>Alertas</div>
          <div onClick={() => {
            setActualPage('torneos');
            setInitialData(null);
          }}>Torneos</div>
          <div onClick={() => {
            setActualPage('arena');
            setInitialData(null);
          }}>Arena</div>
          <div onClick={() => {
            setActualPage('tutorial');
            setInitialData(null);
          }}>Tutorial</div>
        </div>
        {actualPage == 'forms' ? <FormComp formFields={actualForm} apiPath={actualPath} initialData={initialData}></FormComp> : ''}
        {actualPage == 'consejo' ? <Consejo></Consejo> : ''}
        {actualPage == 'apuestas' ? <Apuestas></Apuestas> : ''}
        {actualPage == 'dar' ? (
          <>
            <div className='navTops heroes unselectable'>
              <div onClick={() => setDarTab('overbox')}>Overbox</div>
              <div onClick={() => setDarTab('reward')}>Recompensa</div>
              <div onClick={() => setDarTab('birux')}>Birux</div>
            </div>
            {darTab == 'overbox' ? <AdminOverbox></AdminOverbox> : ''}
            {darTab == 'reward' ? <AdminReward></AdminReward> : ''}
            {darTab == 'birux' ? <AdminBirux></AdminBirux> : ''}
          </>
        ) : ''}
        {actualPage == 'codeReward' ? <AdminCodeReward></AdminCodeReward> : ''}
        {actualPage == 'drops' ? <AdminDrops></AdminDrops> : ''}
        {actualPage == 'ligas' ? <AdminLigas></AdminLigas> : ''}
        {actualPage == 'metricas' ? <AdminMetricas></AdminMetricas> : ''}
        {actualPage == 'eventos' ? <AdminEventos></AdminEventos> : ''}
        {actualPage == 'alertas' ? <AdminAlertas></AdminAlertas> : ''}
        {actualPage == 'torneos' ? <AdminTorneos></AdminTorneos> : ''}
        {actualPage === 'arena' ? <AdminArena></AdminArena> : ''}
        {actualPage === 'tutorial' ? <AdminTutorial></AdminTutorial> : ''}
      </div>
    </div>
  )
}

export default AdminPanel;
